// extracted by mini-css-extract-plugin
export default {"container":"CmZNpDjkMsfU50fKn164","content":"P6yqh23G_bcd2M4sOdtv"};